import Instagram from '@mui/icons-material/Instagram';
import Facebook from '@mui/icons-material/Facebook';
import LinkedIn from '@mui/icons-material/LinkedIn';
import Pinterest from '@mui/icons-material/Pinterest';

// Nirva's active social platforms. Shared by the floating SocialSidebar and the
// Footer so the links live in one place.
export const SOCIAL_LINKS = [
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/mynirva/',
    Icon: Instagram,
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/61589422377705/',
    Icon: Facebook,
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/mynirva/',
    Icon: LinkedIn,
  },
  {
    name: 'Pinterest',
    url: 'https://www.pinterest.com/mynirva/',
    Icon: Pinterest,
  },
];
